<div class="return-style">
  <div class="row">
    <div class="col-xs-12 col-md-12 col-sm-12 col-lg-8 return-dashboard">
      <div class="tabs-Section-Container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            @if (tabSelected === 'createReturn') {
              <span class="tab-Selected">
              {{'Create a return'}}</span>
            }
            @if (tabSelected === 'returnHistory') {
              <span class="tab-Selected returnHistory">
              {{'Return history'}}</span>
            }
          </div>
          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 large-Device-Tabs">
            <ul class="nav nav-tabs">
              <li class="nav-item mr-3" [ngClass]="{'nav-Item-Border': tabSelected == 'createReturn'}">
                <span (click)="tabNavigation('createReturn', 'createReturn')">
                  {{'Create a return'}}
                </span>
              </li>
              <li class="nav-item" [ngClass]="{'nav-Item-Border': tabSelected == 'returnHistory'}">
                <span (click)="tabNavigation('returnHistory', 'returnHistory')">
                  {{'Return history'}}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="tab-contents mt-4">
        <div id="createReturn">
          <app-create-return></app-create-return>
        </div>
        <div id="returnHistory">
          <app-return-history></app-return-history>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xs-12 col-sm-12 col-lg-4 account-style">
      <app-my-account></app-my-account>
    </div>
  </div>
</div>